const getters = {
  buttonAuth: state => state.auth.buttonAuth,
  routerAuth: state => state.auth.routerAuth,
  menuAuth: state => state.auth.menuAuth,
}

export default getters
